import React, { PropTypes } from 'react'
import Options from '../options'
import cx from 'classnames'

export const DataCard = ({children, className, ...rest}) => (
  <div className={cx('data-card', className)} {...rest}>
    {children}
  </div>
)

export const DataCardHeader = ({text, className = ''}) => (
  <div className={cx('data-card-header', className)}>
    <p>{text}</p>
  </div>
)

export class OptionsMenu extends React.Component {
  constructor (props) {
    super(props)

    this.toggleOptions = this.toggleOptions.bind(this)
    this.state = {
      showOptions: this.props.showOptions || false
    }
  }

  toggleOptions () {
    if (this.state.showOptions) {
      this.props.onHide && this.props.onHide()
      this.setState({
        showOptions: false
      })
    } else {
      this.props.onReveal && this.props.onReveal()
      this.setState({
        showOptions: true
      })
    }
  }

  render () {
    let optionsMenu = null

    if (this.state.showOptions) {
      optionsMenu = <Options optionItems={this.props.optionItems} toggleOptions={this.toggleOptions.bind(this)} />
    }

    const classNames = cx('options-container', { hidden: this.props.optionItems.length === 0 })

    return (
      <div>
        <div className={classNames}>
          {optionsMenu}
        </div>
        <button
          onClick={this.toggleOptions.bind(this)}
          className={cx('drop-down-icon', this.props.buttonClasses)}
        />
      </div>
    )
  }
}

OptionsMenu.propTypes = {
  optionItems: PropTypes.array.isRequired
}

export const Details = ({children}) => (
  <div className='details'>
    {children}
  </div>
)

export const Dot = () => (
  <div className='dot-seperator' />
)

export const Title = ({text}) => (
  <h3 className='location-name'>{text}</h3>
)

Title.propTypes = {
  text: PropTypes.string.isRequired
}

export const TimeFrame = ({text}) => (
  <span className='time-frame'>{text}</span>
)

TimeFrame.propTypes = {
  text: PropTypes.string.isRequired
}

export const Message = ({text, children}) => (
  <div className='assigned-to'>
    <span>{text}</span>
  </div>
)

Message.propTypes = {
  text: PropTypes.string.isRequired
}

export const MessageWithPrefix = ({ text, prefix = '' }) => (
  <div className='assigned-to'>
    {prefix}
    <span>{text}</span>
  </div>
)

export const Badge = ({text, color, additionalClasses = '', right = false}) => (
  <span className={cx('badge', additionalClasses, { right })} style={{ backgroundColor: color }}>{text}</span>
)

Badge.propTypes = {
  text: PropTypes.node.isRequired,
  color: PropTypes.string
}

export const DarkBlueBadge = ({text}) => (
  <Badge text={text} color='#0E4270' />
)

DarkBlueBadge.propTypes = {
  text: PropTypes.node.isRequired
}

export const LightBlueBadge = ({text}) => (
  <Badge text={text} color='#1C75C3' />
)

LightBlueBadge.propTypes = {
  text: PropTypes.string.isRequired
}

export const OrangeBadge = ({text, additionalClasses}) => (
  <Badge text={text} color='#DC6911' additionalClasses={additionalClasses} />
)

OrangeBadge.propTypes = {
  text: PropTypes.string.isRequired
}

export const RedBadge = ({text, additionalClasses}) => (
  <Badge text={text} color='#9E1417' additionalClasses={additionalClasses} />
)

RedBadge.propTypes = {
  text: PropTypes.string.isRequired
}

export const TealBadge = ({text, ...rest}) => (
  <Badge key={text} color='#109E9A' text={text} {...rest} />
)

TealBadge.propTypes = {
  text: PropTypes.string.isRequired
}

export const GrayBadge = ({text}) => (
  <Badge key={text} color='gray' text={text} />
)

GrayBadge.propTypes = {
  text: PropTypes.string.isRequired
}

export const YellowBadge = ({text, additionalClasses}) => (
  <Badge key={text} color='#EAD200' text={text} additionalClasses={additionalClasses} />
)

YellowBadge.propTypes = {
  text: PropTypes.string.isRequired
}

export const GreenBadge = ({text, additionalClasses}) => (
  <Badge key={text} color='#3C8E3C' text={text} additionalClasses={additionalClasses} />
)

GreenBadge.propTypes = {
  text: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/data-card/data-card-parts.js